module.exports = __webpack_public_path__ + "static/nutrino-home-pinapple-487fde87bd55c23644705eecd4f85f4a.png";